import React, { useState, useEffect } from "react";
import { Table, Spin } from "antd";
import axios from "axios";
import Uri from "../../Uri";
import { Modal, Button } from "react-bootstrap";
import Helper from "../helpers/Helper";
import PaginationComponent from "../utils/PaginationComponent";
import ErrorMsgBarParty from "../utils/ErrorMsgBarParty";
import Swal from 'sweetalert2';
import { useAxios } from "../../App";
import { useMsal } from "@azure/msal-react";

export default function Party2EstabilishedEao(props) {
    const axios = useAxios();
    const { instance: msalInstance } = useMsal();

    const authToken = localStorage.getItem("token");

    let [party2EstabilishedEao, setParty2EstabilishedEao] = useState("");
    let [party2EstabilishedEaoUpdate, setParty2EstabilishedEaoUpdate] = useState("");
    let [dataSource, setDataSource] = useState([]);
    let [dataSourceOld, setDataSourceOld] = useState([]);
    let [isInvalid, setIsInvalid] = useState();
    let [isInvalidUpdate, setIsInvalidUpdate] = useState();
    let [idData, setIdData] = useState("");
    let [loading, setLoading] = useState(true);
    let [isError, setIsError] = useState(false);

    let [currentPage, setCurrentPage] = useState();
    let [pageSize, setPageSize] = useState();
    let [totalData, setTotalData] = useState();

    const [showUpdate, setShowUpdate] = useState();
    const [showDelete, setShowDelete] = useState();

    function handleCloseDelete(e) {

        setShowDelete(false);

    };
    function handleShowDelete(e) {

        setShowDelete(true);

    }

    function handleCloseUpdate(e) {

        setShowUpdate(false);

    };

    function handleShowUpdate(e) {

        setShowUpdate(true);

    }

    function _onChangeParty2EstabilishedEao(e) {

        e.preventDefault();

        if (e.target.value) {

            setParty2EstabilishedEao(e.target.value);

        } else {

            setParty2EstabilishedEao("");

        }

    }

    function _onChangeParty2EstabilishedEaoUpdate(e) {

        e.preventDefault();

        if (e.target.value) {

            setParty2EstabilishedEaoUpdate(e.target.value);

        } else {

            setParty2EstabilishedEaoUpdate("");

        }

    }

    async function _saveData(e) {

        e.preventDefault();

        if (!party2EstabilishedEao) {

            setIsInvalid(true);

            setTimeout(() => setIsInvalid(false), 3000);

        } else {

            if ((party2EstabilishedEao.split(',').length > 1) || (party2EstabilishedEao.split(';').length > 1)) {

                setIsError(true);
                setTimeout(() => setIsError(false), 3000)

            } else {

                let data = {

                    "name": party2EstabilishedEao,
                    "created_by": localStorage.getItem("usernameLogin"),
                    "updated_by": localStorage.getItem("usernameLogin")

                }

                await axios.post(Uri.rootUri + `master/party/two/`, data, { headers: { "Authorization": `Bearer ${authToken}` } })
                    .then(async function (response) {

                        caches.delete("party2");// delete cache for update data in cache
                        // console.log(response);

                        let cacheName = {

                            "name": "party2",
                            "created_by": localStorage.getItem("usernameLogin"),
                            "updated_by": localStorage.getItem("usernameLogin")

                        }

                        await axios.post(Uri.rootUri + `cache/`, cacheName)
                            .then(function (response) {

                                // console.log(response);


                            })
                            .catch(function (error) {


                                console.log(error);

                            });

                        _loadDataAll("party2");

                        setParty2EstabilishedEao("");

                        Helper.alert("Success", "success", "Success save data", 3000);

                        _loadData(currentPage, pageSize);

                    })
                    .catch(function (error) {

                        // console.log(error);
                        let objError = error.toJSON();

                        if (objError.status == 400) {

                            Helper.alert("Success", "success", "This party value already exist", 3000);

                        }



                    });

            }
        }

    }

    async function _updateParty2EstabilishedEao(e) {

        e.preventDefault();

        if (!party2EstabilishedEaoUpdate) {

            setIsInvalidUpdate(true);

            setTimeout(() => setIsInvalidUpdate(false), 3000);

        } else {

            if ((party2EstabilishedEaoUpdate.split(',').length > 1) || (party2EstabilishedEaoUpdate.split(';').length > 1)) {

                setIsError(true);
                setTimeout(() => setIsError(false), 3000)

            } else {

                let data = {

                    "name": party2EstabilishedEaoUpdate,
                    "updated_by": localStorage.getItem("usernameLogin")

                }

                await axios.put(Uri.rootUri + `master/party/two/${idData}/`, data, { headers: { "Authorization": `Bearer ${authToken}` } })
                    .then(async function (response) {

                        // console.log(response);
                        caches.delete("party2");// delete cache for update data in cache

                        let cacheName = {

                            "name": "party2",
                            "created_by": localStorage.getItem("usernameLogin"),
                            "updated_by": localStorage.getItem("usernameLogin")

                        }

                        await axios.post(Uri.rootUri + `cache/`, cacheName)
                            .then(function (response) {

                                // console.log(response);


                            })
                            .catch(function (error) {


                                console.log(error);

                            });

                        _loadDataAll("party2");

                        setParty2EstabilishedEaoUpdate("");

                        Helper.alert("Success", "success", "Success update data", 3000);

                        setShowUpdate(false);

                        _loadData(currentPage, pageSize);

                    })
                    .catch(function (error) {

                        // console.log(error);

                        setShowUpdate(false);



                    });

            }
        }

    }

    async function _approveDelete(id, confirmation) {
        let data = {
            "confirmation": confirmation,
            "deleted_by": localStorage.getItem("usernameLogin")
        }

        try {

            await axios.put(Uri.rootUri + `master/party/two/${id}/delete/`, data, { headers: { "Authorization": `Bearer ${authToken}` } })
                .then(async function (response) {
                    caches.delete("party2");// delete cache for update data in cache
                    // console.log(response);
                    let cacheName = {
                        "name": "party2",
                        "created_by": localStorage.getItem("usernameLogin"),
                        "updated_by": localStorage.getItem("usernameLogin")
                    }
                    await axios.post(Uri.rootUri + `cache/`, cacheName)
                        .catch(function (error) {
                            console.log(error);
                        });

                    _loadDataAll("party2");
                    setShowDelete(false);
                    Helper.alert("Success", "success", "Success delete data", 3000);
                    _loadData(currentPage, pageSize);
                })
        } catch (error) {
            setShowDelete(false);
            console.log(error);
            return error.response;
        }

    }
    async function _deleteParty2EstabilishedEao(e, id) {

        e.preventDefault();
        setShowDelete(false);
        Swal.fire({
            title: 'Loading...',
            html: 'Please wait just a moment',
            timerProgressBar: true,
            didOpen: () => Swal.showLoading()
        })
        if (id) {
            const response = await _approveDelete(id, false);
            console.log(response);
            if (response?.status == 400 && response?.data?.res?.message == "Party is used in incident") {
                Helper.dialogConfirmation(`This party is used in ${response?.data?.res?.countOfIncident} incident(s). You cannot revert this operation.`, async () => await _approveDelete(id, true))
            }
        } else {
            setShowDelete(false);
        }

    }


    const columns = [
        {
            title: 'Party 2 : Established EAO',
            dataIndex: 'name',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => a.name.localeCompare(b.name),
            width: '80%',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (text, record, index) => (
                <div className="btn-group" role="group" aria-label="Basic example">
                    <button type="button" className="btn btn-primary btn-sm" onClick={(e) => {
                        handleShowUpdate(e);
                        setParty2EstabilishedEaoUpdate(record.name);
                        setIdData(record.id);
                    }} id="update"><i className="bi bi-pencil-fill"></i>
                    </button>

                    <button type="button" className="btn btn-primary btn-sm"
                        onClick={(e) => {
                            handleShowDelete(e);
                            setIdData(record.id);
                        }} id="delete"><i className="bi bi-trash-fill"></i>
                    </button>
                </div>
            )
        }
    ];

    async function _loadDataAll(cachenameparam) {

        let arrCache = await caches.keys();// get cache

        await axios.get(Uri.rootUri + `cache/`)
            .then(async function (response) {

                //get version data if there is an update
                let dataResponse = response.data;

                //get data cache where cache name
                let resultObjCache = dataResponse.filter(item => item.name === cachenameparam);

                if (!arrCache.includes("party2")) {// if empty cache name in browser

                    // console.log("cache in browser empty");

                    await axios.get(Uri.rootUri + `master/party/two/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                        .then(function (response) {

                            // console.log(response);

                            let dataResponse = response.data;

                            Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/party2`, dataResponse);


                        })
                        .catch(function (error) {

                            console.log(error);

                        });

                    if (resultObjCache.length == 0) {// if data cache in database empty

                        let cacheName = {

                            "name": cachenameparam,
                            "created_by": localStorage.getItem("usernameLogin"),
                            "updated_by": localStorage.getItem("usernameLogin")

                        }

                        await axios.post(Uri.rootUri + `cache/`, cacheName)
                            .then(function (response) {

                                //   console.log(response);


                            })
                            .catch(function (error) {


                                console.log(error);

                            });

                    } else {

                        //   console.log("set version");

                        // if data cache in database not empty
                        Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/version`, resultObjCache);//set cache

                    }

                } else {

                    let resultData = arrCache.filter(x => x == "party2");

                    //Operation Caching Validation

                    resultData.forEach(async cachename => {

                        let cacheStorage = await caches.open(cachename);

                        let party2Response = await cacheStorage.match(Helper.getHostCurrentUrl() + '/party2');
                        //get version in cache for check update data
                        let cacheResponse = await cacheStorage.match(Helper.getHostCurrentUrl() + '/version'); // get data cache where url

                        if (!cacheResponse || cacheResponse == undefined || !party2Response || party2Response == undefined) {// check data valid or no valid

                            await axios.get(Uri.rootUri + `master/party/two/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                                .then(function (response) {

                                    // console.log(response);

                                    let dataResponse = response.data;

                                    Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/party2`, dataResponse);


                                })
                                .catch(function (error) {

                                    console.log(error);

                                });

                            if (resultObjCache.length == 0) {// if data cache in database empty

                                let cacheName = {

                                    "name": cachenameparam,
                                    "created_by": localStorage.getItem("usernameLogin"),
                                    "updated_by": localStorage.getItem("usernameLogin")

                                }

                                await axios.post(Uri.rootUri + `cache/`, cacheName)
                                    .then(function (response) {

                                        // console.log(response);


                                    })
                                    .catch(function (error) {


                                        console.log(error);

                                    });

                            } else {

                                // if data cache in database not empty
                                Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/version`, resultObjCache);//set cache

                            }

                        } else {

                            let dataResponseVersion = await cacheResponse.json();

                            let dataResponseParty2 = await party2Response.json();

                            if (!dataResponseVersion || dataResponseVersion.length == 0 || !dataResponseParty2 || dataResponseParty2.length == 0) {/*check data into cache empty or not empty*/

                                await axios.get(Uri.rootUri + `master/party/two/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                                    .then(function (response) {

                                        // console.log(response);

                                        let dataResponse = response.data;

                                        Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/party2`, dataResponse);


                                    })
                                    .catch(function (error) {

                                        console.log(error);

                                    });

                                if (resultObjCache.length == 0) {// if data cache in database empty

                                    let cacheName = {

                                        "name": cachenameparam,
                                        "created_by": localStorage.getItem("usernameLogin"),
                                        "updated_by": localStorage.getItem("usernameLogin")

                                    }

                                    await axios.post(Uri.rootUri + `cache/`, cacheName)
                                        .then(function (response) {

                                            // console.log(response);

                                        })
                                        .catch(function (error) {


                                            console.log(error);

                                        });

                                } else {

                                    // if data cache in database not empty
                                    Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/version`, resultObjCache);//set cache

                                }

                            } else {

                                // dataResponseVersion and dataResponseParty2 there must be !

                                if (resultObjCache.length == 0) {// if data cache in database empty

                                    await axios.get(Uri.rootUri + `master/party/two/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                                        .then(function (response) {

                                            // console.log(response);

                                            let dataResponse = response.data;

                                            Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/party2`, dataResponse);


                                        })
                                        .catch(function (error) {

                                            console.log(error);

                                        });

                                    let cacheName = {

                                        "name": cachenameparam,
                                        "created_by": localStorage.getItem("usernameLogin"),
                                        "updated_by": localStorage.getItem("usernameLogin")

                                    }

                                    await axios.post(Uri.rootUri + `cache/`, cacheName)
                                        .then(function (response) {

                                            // console.log(response);

                                        })
                                        .catch(function (error) {


                                            console.log(error);

                                        });

                                } else {

                                    //check version  cache local browser you and database api , resultObjCache there must be !
                                    let resultVersion = resultObjCache[0].version !== dataResponseVersion[0].version ? true : false;

                                    if (resultVersion) {

                                        // console.log("Update cache new version ");

                                        await axios.get(Uri.rootUri + `master/party/two/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                                            .then(function (response) {

                                                // console.log(response);

                                                let dataResponse = response.data;

                                                Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/party2`, dataResponse);


                                            })
                                            .catch(function (error) {

                                                console.log(error);

                                            });

                                        Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/version`, resultObjCache);//set cache

                                    } else {

                                        Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/party2`, dataResponseParty2);

                                        Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/version`, resultObjCache);//set cache

                                    }

                                }


                            }

                        }

                    });

                }


            })
            .catch(function (error) {

                console.log(error);

            });


        //     let arrCache = await caches.keys();// get cache

        //     if(!arrCache.includes("party2")){

        //         await axios.get(Uri.rootUri + `master/party/two/`, { headers: {"Authorization" : `Bearer ${authToken}`} })
        //         .then(function(response){

        //             let dataResponse = response.data;

        //             Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/party2` , dataResponse);

        //         })
        //         .catch(function(error){

        //             console.log(error);


        //         });

        //     }else{

        //         let resultDataIncident = arrCache.filter( x => x == "party2"); //get where cache name

        //         resultDataIncident.map(async cachename => {

        //         let cacheStorage = await caches.open(cachename);

        //         let cacheResponse = await cacheStorage.match(Helper.getHostCurrentUrl() + `/party2`);

        //         if(!cacheResponse || cacheResponse == undefined){

        //             await axios.get(Uri.rootUri + `master/party/two/`, { headers: {"Authorization" : `Bearer ${authToken}`} })
        //             .then(function(response){

        //                 let dataResponse = response.data;

        //                 Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/party2` , dataResponse);

        //             })
        //             .catch(function(error){

        //                 console.log(error);


        //             });

        //         }else{

        //             let dataResponse = await cacheResponse.json();

        //             if(!dataResponse || dataResponse.length == 0){

        //                 await axios.get(Uri.rootUri + `master/party/two/`, { headers: {"Authorization" : `Bearer ${authToken}`} })
        //                 .then(function(response){

        //                     let dataResponse = response.data;

        //                     Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/party2` , dataResponse);

        //                 })
        //                 .catch(function(error){

        //                     console.log(error);


        //                 });

        //             }

        //         }

        //         });
        //     }

        // }

    }

    async function _loadData(page, pageSize) {

        setCurrentPage(page);

        setPageSize(pageSize);

        await axios.get(Uri.rootUri + `master/party/two/?page=${page}&page_size=${pageSize}`, { headers: { "Authorization": `Bearer ${authToken}` } })
            .then(function (response) {

                let dataResponse = response.data;

                setTotalData(dataResponse.count);

                setDataSource(dataResponse.results);

                setDataSourceOld(dataResponse.results);

            })
            .catch(function (error) {

                console.log(error);


            });

        let arrCache = await caches.keys();// get cache

        if (!arrCache.includes("party2")) {

            await axios.get(Uri.rootUri + `master/party/two/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                .then(function (response) {

                    let dataResponse = response.data;

                    setDataSource(dataResponse);

                    setDataSourceOld(dataResponse);

                    Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/party2`, dataResponse);

                })
                .catch(function (error) {

                    console.log(error);


                })

        } else {


            let resultData = arrCache.filter(x => x == "party2"); //get where cache name

            resultData.forEach(async cachename => {

                let cacheStorage = await caches.open(cachename);

                let cacheResponse = await cacheStorage.match(Helper.getHostCurrentUrl() + `/party2`);

                // console.log(dataResponse);

                if (!cacheResponse || cacheResponse == undefined) {// if data in cache empty

                    await axios.get(Uri.rootUri + `master/party/two/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                        .then(function (response) {

                            let dataResponse = response.data;

                            setDataSource(dataResponse);

                            setDataSourceOld(dataResponse);

                            Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/party2`, dataResponse);

                        })
                        .catch(function (error) {

                            console.log(error);


                        })

                } else { //if data in cache not empty


                    let dataResponse = await cacheResponse.json();

                    if (!dataResponse || dataResponse.length == 0) {

                        await axios.get(Uri.rootUri + `master/party/two/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                            .then(function (response) {

                                let dataResponse = response.data;

                                setDataSource(dataResponse);

                                setDataSourceOld(dataResponse);

                                Helper.addDataIntoCache("party2", Helper.getHostCurrentUrl() + `/party2`, dataResponse);

                            })
                            .catch(function (error) {

                                console.log(error);


                            })

                    } else {


                        setDataSource(dataResponse);

                        setDataSourceOld(dataResponse);

                    }


                }


            });


        }
    }

    async function onChange(page, pageSize) {

        // console.log(page,pageSize,currentPage); //page = new previous  page and new next page

        setPageSize(pageSize);

        setCurrentPage(page);

        let currentPageOnChange = page ? `page=${page}&` : 'page=1&';

        let currentPageSizeOnChange = pageSize ? `page_size=${pageSize}&` : 'page_size=20&';

        await axios.get(Uri.rootUri + `master/party/two/?${currentPageOnChange}${currentPageSizeOnChange}`, { headers: { "Authorization": `Bearer ${authToken}` } })
            .then(function (response) {

                let dataResponse = response.data;

                setTotalData(dataResponse.count);

                setDataSource(dataResponse.results);

                setDataSourceOld(dataResponse.results);

            })
            .catch(function (error) {

                console.log(error);

            });

    }

    useEffect(() => {
      const effect = async () => {

        //ajax call pending set loading
        // axios.setLoadingInterceptors(setLoading);
        await Helper.authorizationLogin(axios, msalInstance);

        await _loadData(1, 100);
        await _loadDataAll("party2");
        
        setLoading(false);
      }
      effect();
    }, []);
    return (
        <Spin size="large" spinning={loading}>
            <div className="party2estabilishedeao">
                <div className="row">
                    <div className="col-lg-4">
                        <h4>Add New Party 2 : Established EAO:</h4>
                        <div className="mb-3">
                            <label htmlFor="party2estabilishedeao">Party 2 : Established EAO</label>
                            {isInvalid && !party2EstabilishedEao ?

                                <div id="party2estabilishedeao" className="text-danger mb-1" style={{ fontSize: 14 }}>
                                    Please insert Party 2 : Established EAO.
                                </div>
                                :
                                <></>
                            }
                            <input type="text" className="form-control" name="party2estabilishedeao" id="party2estabilishedeao" onChange={_onChangeParty2EstabilishedEao} value={party2EstabilishedEao && party2EstabilishedEao} />
                        </div>
                        {(isError && !!!showUpdate) && <ErrorMsgBarParty />}
                        <button type="submit" className="btn btn-primary" style={{ width: "100%" }} onClick={_saveData}><i className="bi bi-plus-circle-fill"></i> Add to Master Data</button>
                    </div>
                    <div className="col-lg-8">
                        <h4>Party 2 : Established EAO Data</h4>
                        <Table
                            columns={columns}
                            dataSource={dataSource}
                            pagination={false}
                            scroll={{ x: 'max-content' }}
                        />
                        <div className="text-center mt-3">
                            <PaginationComponent
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                onChange={onChange}
                                showSizeChanger={false}
                                total={totalData ? totalData : 0}
                                defaultPageSize={20}
                            />
                        </div>
                    </div>
                    <>
                        <Modal show={showUpdate} onHide={handleCloseUpdate} id={`update`}>
                            <Modal.Header closeButton>
                                <Modal.Title>Edit Data</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="mb-3">
                                    <label htmlFor="party2estabilishedeao">Party 2 : Established EAO</label>
                                    {isInvalidUpdate && !party2EstabilishedEaoUpdate ?

                                        <div id="party2estabilishedeao" className="text-danger mb-1" style={{ fontSize: 14 }}>
                                            Please insert Party 2 : Established EAO.
                                        </div>
                                        :
                                        <></>
                                    }
                                    <input type="text" className="form-control" name="party2estabilishedeao" id="party2estabilishedeao" onChange={_onChangeParty2EstabilishedEaoUpdate} value={party2EstabilishedEaoUpdate && party2EstabilishedEaoUpdate} />
                                </div>
                                {(isError && showUpdate) && <ErrorMsgBarParty />}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseUpdate}>
                                    Close
                                </Button>
                                <Button type="submit" variant="primary" onClick={_updateParty2EstabilishedEao}>
                                    Save
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={showDelete} onHide={handleCloseDelete} id={`delete`}>
                            <Modal.Header closeButton>
                                <Modal.Title>Confirmation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p className='m-0'>Delete this data ?</p>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseDelete}>
                                    Close
                                </Button>
                                <Button variant="primary" onClick={(e) => _deleteParty2EstabilishedEao(e, idData)}>
                                    Ok
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </>

                </div>
            </div>
        </Spin>
    )
}